import { Suspense } from "react";
import { lazyWithRetry } from "@/lib/lazyWithRetry";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import LazyWhenVisible from "@/components/LazyWhenVisible";
import { homepageFaqJsonLd } from "@/components/HomepageFAQ";

const SocialProof = lazyWithRetry(() => import("@/components/SocialProof"));

const JourneyMap = lazyWithRetry(() => import("@/components/JourneyMap"));
const GrowthPath = lazyWithRetry(() => import("@/components/GrowthPath"));
const HomepageFAQ = lazyWithRetry(() => import("@/components/HomepageFAQ"));
const CtaSection = lazyWithRetry(() => import("@/components/CtaSection"));

const definedTermsJsonLd = {
  "@context": "https://schema.org",
  "@type": "DefinedTermSet",
  name: "GrowAgentic Glossary",
  hasDefinedTerm: [
    {
      "@type": "DefinedTerm",
      name: "Answer Engine Optimization",
      description:
        "The practice of making enterprise content, data, and transactions discoverable, understandable, trusted, rankable, and executable by AI agents through structured data, schemas, and machine-readable formats.",
      inDefinedTermSet: "GrowAgentic Glossary",
    },
    {
      "@type": "DefinedTerm",
      name: "Agentic Commerce",
      description:
        "Commerce mediated by autonomous AI agents that discover, evaluate, recommend, and transact on behalf of users — compressing the traditional multi-step buyer journey into a single agent-driven flow.",
      inDefinedTermSet: "GrowAgentic Glossary",
    },
  ],
};

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="GrowAgentic Commerce | Make Your Business AI Agent Ready"
        description="GrowAgentic helps enterprises become AI agent ready — discoverable, trusted, and transactable by AI agents through Answer Engine Optimization."
        canonical="/"
        jsonLd={[definedTermsJsonLd, homepageFaqJsonLd]}
      />
      <Navbar />
      <main id="main-content">
        <HeroSection />
        <LazyWhenVisible>
          <Suspense fallback={null}>
            <JourneyMap />
          </Suspense>
        </LazyWhenVisible>
        <Suspense fallback={null}>
          <SocialProof />
        </Suspense>
        <LazyWhenVisible>
          <Suspense fallback={null}>
            
            <GrowthPath />
            <HomepageFAQ />
            <CtaSection />
          </Suspense>
        </LazyWhenVisible>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
